import { Announcement } from './Announcement';
import { BaseModel } from './BaseModel';
import { Notification } from './Notification';

export enum NavBarPosition {
    LEFT,
    TOP,
}

interface UserPreferences {
    navbarPosition: NavBarPosition;
    language: string;
    physgunFeedbackQuestionnaireDismissedAt?: string;
}

interface UserDiscord {
    id: string;
    username: string;
}

export class User extends BaseModel {
    public email = '';
    public nameFirst = '';
    public nameLast = '';
    public has2fa = false;
    public preferences: UserPreferences | undefined;
    // Per-node "primary server" map sourced from the
    // user_primary_servers table on the backend. Keys are stringified
    // node ids (the panel's User transformer casts each row's
    // node_id to a string for JSON-key stability); values are server
    // UUIDs. Missing entry = no preference on that node; daemon
    // falls back to biggest-by-memory.
    public primaryServerByNode: Record<string, string> = {};
    public discord: UserDiscord | undefined;
    public createdAt: string = '';

    public get fullName(): string {
        return `${this.nameFirst} ${this.nameLast}`;
    }

    public get selectorName(): string {
        return `${this.nameFirst} ${this.nameLast} (${this.email})`;
    }

    // Currently authenticated user props (or if in admin area)
    public id = -1;

    public mfaMethods: MFAMethods[] = [];
    public rootAdmin = false;
    public supportOp = false;
    public ssoEnabled = false;

    public get permissions(): string[] {
        return this.getRelationship('permissions') || [];
    }

    public get announcements(): Announcement[] {
        return this.getRelationship('announcements') || [];
    }

    public get notifications(): Notification[] {
        return this.getRelationship('notifications') || [];
    }

    public hasUnreadAnnouncements() {
        return this.announcements.length > 0;
    }

    public hasUnreadNotifications() {
        return this.notifications.length > 0;
    }

    // Admin-only props
    public externalId = -1;
    public supportOpBypass = false;
    public sso = false;
    public serversCount = 0;
    public subuserOfCount = 0;
    public lastVisitedNode?: string | null = null;

    getRouteName() {
        return 'user';
    }

    getRouteID() {
        return this.id.toString();
    }
}
